import { getTopics } from '@/services/topic.service';
import { useQuery } from '@tanstack/react-query';

/**
 * Custom hook to fetch all topic options.
 *
 * @returns {Object} The query result object from React Query.
 */

export default function useTopicOptionsQuery() {
  return useQuery({
    queryKey: ['topics-options', 'all'],
    queryFn: () =>
      getTopics({
        pageSize: null,
        offset: null,
      }),
    refetchOnWindowFocus: false,
  });
}
